/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Assign_Speakers_CompleteInputs */

const en_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Assign Speakers Complete`)
};

const fr_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribution automatique des intervenants terminée`)
};

const de_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Lautsprecherzuweisung abgeschlossen`)
};

const it_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnazione automatica altoparlanti completata`)
};

const ru_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое назначение динамиков завершено.`)
};

const es_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignación automática de altavoces completa`)
};

const zh_cn2_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动分配发言人完成`)
};

const ja_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの自動割り当てが完了しました`)
};

const hi_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर स्वतः असाइन करें (पूर्ण)`)
};

const pt_pt2_auto_assign_speakers_complete = /** @type {(inputs: Auto_Assign_Speakers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuição automática de alto-falantes concluída`)
};

/**
* | output |
* | --- |
* | "Auto Assign Speakers Complete" |
*
* @param {Auto_Assign_Speakers_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_assign_speakers_complete = /** @type {((inputs?: Auto_Assign_Speakers_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Assign_Speakers_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_assign_speakers_complete(inputs)
	if (locale === "de") return de_auto_assign_speakers_complete(inputs)
	if (locale === "it") return it_auto_assign_speakers_complete(inputs)
	if (locale === "ru") return ru_auto_assign_speakers_complete(inputs)
	if (locale === "es") return es_auto_assign_speakers_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_assign_speakers_complete(inputs)
	if (locale === "ja") return ja_auto_assign_speakers_complete(inputs)
	if (locale === "hi") return hi_auto_assign_speakers_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_assign_speakers_complete(inputs)
	return en_auto_assign_speakers_complete(inputs)
});